/// <reference path="../../../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import ConnectionType = Application.Models.ConnectionType;
    import PresetPathBlock = Models.PresetPathBlock;
    import PresetPathBlockGroup = Models.PresetPathBlockGroup;
    import StickyConnection = Application.Models.StickyConnection;

    export interface IBulkAddPresetPathsModalControllerScope extends ng.IScope {
        name: string;
        password: string;
        sourceBlocksGroup: PresetPathBlockGroup[];
        selectedSourceBlocksGroup: PresetPathBlockGroup;
        destBlocksGroup: PresetPathBlockGroup[];
        selectedDestBlocksGroup: PresetPathBlockGroup;
        modalClose: () => void;
        modalSave: () => void;
        clear: () => void;
        isTsoip: boolean;
        modalTitle: string;
        updatePassword: (password: string) => void;
        passphraseError: boolean;
    }

    export class BulkAddPresetPathsModalController {

        public static templateUrl: string = "decorators/modals/admin/preset-paths/bulk-add-preset-paths-modal.html";
        public static id: string = "#id-bulk-add-preset-path-modal";
        public static $name: string = "BulkAddPresetPathsModalController";
        public static $inject: string[] = [
            '$scope',
            'close',
            '$timeout',
            'presetPathService',
            'blocks',
            'presetPathType'
        ];
        private presetPathType: string;

        constructor($scope: IBulkAddPresetPathsModalControllerScope,
                    close: (response: string) => void,
                    $timeout: ng.ITimeoutService,
                    private presetPathService: Services.PresetPathService,
                    blocks: PresetPathBlock[],
                    presetPathType: string) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            blocks = blocks.filter((block: PresetPathBlock) => {
                return block.presetPathBlockConnections && block.presetPathBlockConnections.length > 0;
            });

            $scope.isTsoip = presetPathType === ConnectionType.TSOIP;
            this.presetPathType = presetPathType;
            $scope.modalTitle = this.presetPathType + " Bulk Preset Path creation";
            const sourceBlocks: PresetPathBlock[] = AddPresetPathsModalController.filterSourceBlocks(blocks, this.presetPathType);
            const sinkBlocks: PresetPathBlock[] = AddPresetPathsModalController.filterSinkBlocks(blocks, this.presetPathType);

            const sourceBlocksGroup: PresetPathBlockGroup[] = this.groupBlocksBySerial(sourceBlocks, 'OUTPUT');
            const destBlocksGroup: PresetPathBlockGroup[] = this.groupBlocksBySerial(sinkBlocks, 'INPUT');
            
            $scope.sourceBlocksGroup = sourceBlocksGroup;
            $scope.destBlocksGroup = destBlocksGroup;

            $scope.$watch('selectedSourceBlocksGroup', (newVal: PresetPathBlockGroup, oldVal: PresetPathBlockGroup) => {
                // a source has been selected
                if (newVal !== oldVal) {
                    if($scope.destBlocksGroup.length === 0 ) {
                        $scope.selectedDestBlocksGroup = undefined;
                    }
                    if (newVal) {
                        if ($scope.selectedDestBlocksGroup == undefined || $scope.selectedDestBlocksGroup.numberOfBlocks !== newVal.numberOfBlocks) {
                            $scope.destBlocksGroup = destBlocksGroup.filter((blockGroup) => {
                                return blockGroup.numberOfBlocks === newVal.numberOfBlocks
                                    && blockGroup.connectionType === newVal.connectionType
                                    && blockGroup.push === newVal.push;
                            });
                        }

                        if (StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === newVal.blocks[0].blockTypeNaturalKey)) {
                            if ($scope.selectedDestBlocksGroup
                                && !StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === $scope.selectedDestBlocksGroup.blocks[0].blockTypeNaturalKey)) {
                                $scope.selectedDestBlocksGroup = undefined;
                            }
                            $scope.destBlocksGroup = this.filterSrcPresetPathDest($scope.destBlocksGroup);
                        }
                    }
                }
            });

            $scope.$watch('selectedDestBlocksGroup', (newVal: PresetPathBlockGroup, oldVal: PresetPathBlockGroup) => {
                // a destination has been selected
                if (newVal !== oldVal) {
                    if($scope.sourceBlocksGroup.length === 0 ) {
                        $scope.selectedSourceBlocksGroup = undefined;
                    }
                    if (newVal) {
                        if ($scope.selectedSourceBlocksGroup == undefined  || $scope.selectedSourceBlocksGroup.numberOfBlocks !== newVal.numberOfBlocks) {
                            $scope.sourceBlocksGroup = sourceBlocksGroup.filter((blockGroup) => {
                                return blockGroup.numberOfBlocks === newVal.numberOfBlocks
                                    && blockGroup.connectionType === newVal.connectionType
                                    && blockGroup.push === newVal.push;
                            });
                        }

                        if (StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === newVal.blocks[0].blockTypeNaturalKey)) {
                            if ($scope.selectedSourceBlocksGroup
                                && !StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === $scope.selectedSourceBlocksGroup.blocks[0].blockTypeNaturalKey)) {
                                $scope.selectedSourceBlocksGroup = undefined;
                            }
                            $scope.sourceBlocksGroup = this.filterSrcPresetPathOrig($scope.sourceBlocksGroup);
                        }

                    }
                }
            });


            $scope.modalClose = (): void => {
                close(undefined);
            };

            $scope.modalSave = (): void => {
                let blockConnectionCoupleIds : Models.IBlockConnectionCouple[] = [];
                // Build Block Connection Couple
                let sourceBlockId = $scope.selectedSourceBlocksGroup.blocks.sort((a: any, b: any) => a.id - b.id).map(block => block.presetPathBlockConnections.filter(blockConnection => blockConnection.direction === 'OUTPUT' && blockConnection.connectionTypeName == this.presetPathType).map(blockConnection => blockConnection.blockConnectionId)[0]);
                let destBlockId = $scope.selectedDestBlocksGroup.blocks.sort((a: any, b: any) => a.id - b.id).map(block => block.presetPathBlockConnections.filter(blockConnection => blockConnection.direction === 'INPUT' && blockConnection.connectionTypeName == this.presetPathType).map(blockConnection => blockConnection.blockConnectionId)[0]);
                for (var _i = 0; _i < sourceBlockId.length; _i++) {
                    let couple : Models.IBlockConnectionCouple = {
                    originId:sourceBlockId[_i],
                    destinationId:destBlockId[_i]
                    }
                    blockConnectionCoupleIds.push(couple);
                }
                if ($scope.sourceBlocksGroup && $scope.destBlocksGroup && $scope.name && $scope.name !== '') {
                    this.presetPathService
                        .createMultiPresetPath({
                            name: $scope.name,
                            password: $scope.password,
                            blockConnectionCoupleIds: blockConnectionCoupleIds
                        })
                        .then(() => {
                            close(undefined);
                        })
                        .catch(reason => {
                            Common.Utils.alertOnError('Error: '+reason.data.message, 'bottom-center');
                        })
                }
            };

            $scope.clear = (): void => {
                $scope.selectedDestBlocksGroup = undefined;
                $scope.selectedSourceBlocksGroup = undefined;

                const sourceBlocksGroup: PresetPathBlockGroup[] = this.groupBlocksBySerial(sourceBlocks, 'OUTPUT');
                const destBlocksGroup: PresetPathBlockGroup[] = this.groupBlocksBySerial(sinkBlocks, 'INPUT');


                $scope.sourceBlocksGroup = sourceBlocksGroup;
                $scope.destBlocksGroup = destBlocksGroup;
            };

            $scope.updatePassword = (password: string): void => {
                $scope.passphraseError = this.checkPassphrase(password);
                $scope.password = password;
            }



        }

        checkPassphrase(newPassphrase: string) {
            return !newPassphrase || newPassphrase.length < 10 || this.validatePassphraseChars(newPassphrase);
          }
      
        validatePassphraseChars(passphrase: string) {
            return passphrase.indexOf('=') !== -1 || passphrase.indexOf('&') !== -1 || passphrase.indexOf('?') !== -1;
        }


        private  filterSrcPresetPathDest(blockGroups: PresetPathBlockGroup[]): PresetPathBlockGroup[] {
            return blockGroups.filter((blockGroup: PresetPathBlockGroup) => {
                return StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === blockGroup.blocks[0].blockTypeNaturalKey);
            });
        }

        private  filterSrcPresetPathOrig(blockGroups: PresetPathBlockGroup[]): PresetPathBlockGroup[] {
            return blockGroups.filter((blockGroup: PresetPathBlockGroup) => {
                return StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === blockGroup.blocks[0].blockTypeNaturalKey);
            });
        }

        private groupBlocksBySerial(blocks: PresetPathBlock[], direction: string): PresetPathBlockGroup[] {
            let blockGroups : PresetPathBlockGroup[] = [];

            blocks.forEach(block => {
                let blockGroup = blockGroups.filter(bg => bg.name === block.serial)[0];
                if(blockGroup != undefined) {
                    blockGroup.blocks.push(block);
                } else {
                    blockGroup = new PresetPathBlockGroup();
                    blockGroup.name = block.serial;
                    blockGroup.direction = direction;
                    let iBlockConnections = block.presetPathBlockConnections.filter(blockConnection => blockConnection.direction === direction
                                                            && blockConnection.connectionTypeName == this.presetPathType);
                    if(iBlockConnections.length == 1) {
                        blockGroup.connectionType = iBlockConnections[0].connectionTypeName;
                        blockGroup.push = iBlockConnections[0].push;
                        blockGroup.blocks.push(block);
                        blockGroups.push(blockGroup);
                    }

                }
            });
            return blockGroups;
        }
    }
}
